<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home reset-password-container">
    <main>
      <h1 class="vtz-h1 vtz-text--center" i18n>
        Reset Password
      </h1>
      <div>
        <mat-horizontal-stepper [linear]="isLinear" #stepper>
          <mat-step [completed]="false">
            <ng-template matStepLabel i18n>Get Code</ng-template>
            <div style="margin-left: 16px;padding-top: 10px;"></div>
            <div class="digits-header">
              <p i18n>Enter the following information to reset your password.</p>
            </div>
            <div class="container">
              <form [formGroup]="getTokenForm">
                <p i18n>Email</p>
                  <input #emailAddress class="vtz-form__input userid" matInput formControlName="emailAddress"
                    [name]="'emailAddress'">
                
                <ng-container>
                  @if(getTokenForm.get('emailAddress')?.invalid && (getTokenForm.get('emailAddress')?.dirty || getTokenForm.get('emailAddress')?.touched)) {
                    <div class="error-message">
                      @if(getTokenForm.get('emailAddress')?.errors?.required) {
                        <div i18n>An email address is required.</div>
                      }
                      @if(getTokenForm.get('emailAddress')?.errors?.email) {
                        <div i18n>Please enter a valid email address.</div>
                      }
                    </div>
                  }
                </ng-container>
              </form>
            </div>
            <div class="ine-next">
              @if(codeSent) {
                <div class="digits-header">
                  <p style="color: green;"><mat-icon>check_circle</mat-icon><span i18n> Please check your SMS for a 6-digit validation code.</span></p>
                  <p i18n>Click "NEXT" to enter the code you received.</p>
                </div>
              }
              <div class="vtz-actions">
                @if(!aboutService.isVotingCenter()) {
                  <ngx-invisible-recaptcha #captchaRef
                    [siteKey]="recaptchaSiteKey"
                    (success)="resolved($event)"
                    aria-hidden="true">
                  </ngx-invisible-recaptcha>
                }
                @if(codeSent) {
                  <button class="button button-primary" (click)="nextScreen()" i18n="Button label">
                    NEXT
                  </button>
                } @else {
                  <div class="button-group">
                    <button i18n class="button-primary" (click)="back()">BACK</button>
                      <div class="vtz-spacer-10"></div>
                    <button class="button button-primary" [disabled]="!getTokenForm.valid" (click)="execute()" i18n="Button label">
                      SEND
                    </button>
                  </div>
                }
              </div>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel i18n>Enter Code</ng-template>
            <div style="margin-left: 16px;padding-top: 10px;"></div>
            <div class="digits-header">
              <p i18n>Please enter the 6-digit code you received by SMS.</p>
            </div>
            <ng-container>
              <div class="vtz-form"> 
                <div id="reset-code" class="otp-field">
                  @for (index of numbers; track index) {
                    <input
                      #codeRef
                      type="text"
                      maxlength="1"
                      pattern="[0-9]"
                      required
                      [attr.aria-label]="'Digit' +(index + 1)+ 'of 6'"               
                      autocomplete="off"
                      (focus)="handleFocus($event)"
                      (input)="handleInput($event, index)"
                      (paste)="handlePaste($event)"
                      (blur)="index === 5 && handleBlur($event)"
                    />
                  }
                </div>
      
                @if(codeForm.get('code')?.hasError('invalidPaste')){
                  <div role="alert" class="vtz-text--center">
                    <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Pasted code must contain exactly 6 numbers.
                    </span>
                  </div>
                }
                @if(codeForm.get('code')?.hasError('invalidCode')){
                  <div role="alert" class="vtz-text--center">
                    <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Exactly six digits are required in this field.
                    </span>
                  </div>
                }
      
              </div>
              @if(codeVerified) {
                <div class="digits-header">
                  <p style="color: green;"><mat-icon>check_circle</mat-icon><span i18n> A temporary password has been sent to your email. Use that password to log in.</span></p>
                  <p i18n>Click "NEXT" to return to the login page.</p>
                </div>
              }
              <div class="vtz-actions">
                @if(codeVerified) {
                  <button class="button button-primary" (click)="toLogin()" i18n="Button label">
                    NEXT
                  </button>
                } @else {
                  <div class="button-group">
                    <button i18n class="button-primary" (click)="cancel()">CANCEL</button>
                    <div class="vtz-spacer-10"></div>
                    <button class="button button-primary" (click)="submit()" [disabled]="!codeForm.valid" i18n="Button label">
                      SEND
                    </button>
                  </div>
                }
              </div>
            </ng-container>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </main>
  </div>
  @if(displaySpinner) {
    <div class="progressSpinner">
      <mat-spinner [diameter]="300" color="primary"></mat-spinner>
      <div class="spinner-warning">
        <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
      </div>
    </div>
  }
</div>